import React, { Component } from "react";
import {
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
} from "reactstrap";
import { Link } from "react-router-dom";
import {
  createTable,
  updateTable,
  removetable,
  getTableList,
  gettableId,
  updatetablestatus,
  getOutlets,
} from "../../Endpoint/Admin/index";
import BranchAssignment from "../../components/Common/BranchAssignment";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, StatCard, StatRow, Table, Chip, Btn,
} from "../../components/Console/ConsoleUI";

import { toast } from "react-toastify";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { canWrite } from "../../services/PermissionService";

/**
 * Tables — console screen C3·08 (Table reservations), floor-plan view.
 *
 * The same create / update / activate / occupy calls as before. The floor plan
 * is drawn from the list already loaded: every table is a tile coloured by its
 * occupancy, which is the one thing a host needs to read at a glance.
 *
 * Both toggle endpoints take the DESIRED state rather than toggling, so the
 * target is computed at the call site (`!x.isActive`). Fields are read exactly
 * as stored: `isActive` true = bookable, `isOccupied` true = a guest is seated.
 */

/** Segmented pill row that navigates. */
const NavPills = ({ items, active }) => (
  <div style={{ display: "flex", padding: 4, borderRadius: 21, background: "#efe2ce" }}>
    {items.map((i) => (
      <Link
        key={i.to}
        to={i.to}
        style={{
          padding: "8px 16px", borderRadius: 17, fontSize: 14, textDecoration: "none",
          background: i.to === active ? C.brown : "transparent",
          color: i.to === active ? "#fff" : C.taupe,
        }}
      >
        {i.label}
      </Link>
    ))}
  </div>
);

/** Compact row action, the console equivalent of the old btn-primary cell. */
const RowBtn = ({ tone, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      height: 32, padding: "0 14px", borderRadius: 16, fontSize: 13,
      fontFamily: "inherit", cursor: "pointer", whiteSpace: "nowrap",
      border: tone === "solid" ? "none" : `1px solid ${C.border}`,
      background: tone === "solid" ? C.brown : "#fff",
      color: tone === "solid" ? "#fff" : C.brown,
    }}
  >
    {children}
  </button>
);

/** Outlet kinds as the backend stores them (models/Outlet.js), for labels. */
const OUTLET_KIND_LABEL = {
  restaurant: "Restaurant",
  cafe: "Café",
  bar: "Bar",
  lounge: "Lounge",
  poolside: "Poolside",
};

/**
 * A table's outletId as the form holds it: "" = branch-wide, else the id.
 * The table can carry an id string, a populated {_id, ...} or null/undefined.
 */
const outletIdOf = (v) => {
  if (!v) return "";
  if (typeof v === "object") return v._id ? String(v._id) : "";
  return String(v);
};

/** A real submit button, so AvForm validation still runs on click. */
const SUBMIT_STYLE = {
  display: "inline-flex", alignItems: "center", justifyContent: "center",
  height: 42, padding: "0 22px", borderRadius: 21, fontSize: 14,
  fontFamily: "inherit", cursor: "pointer", border: "none",
  background: C.brown, color: "#fff",
};

class FormElements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidFile: false,
      previewImage: undefined,
      items: [],
      isLoaded: false,
      updatemodal: false,
      modal: false,
      tableNo: "",
      tableId: null,
      finalAmount: "",
      person: "",
      seats: "",
      branchIds: [],
      excludedBranchIds: [],
      branchOverrides: [],
      // "" = branch-wide (no outlet), else the outlet's id.
      outletId: "",
      // Restaurants/bars for the picker and the list (branch-scoped by the server).
      outlets: [],
      success: {},
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: " ", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: {
        columns: [
          {
            label: "Table No",
            field: "tableNo",
            sort: "asc",
            width: 60,
          },
          {
            label: "Outlet",
            field: "outlet",
            sort: "asc",
            width: 100,
          },
          {
            label: "Person (Single, Couple, Family)",
            field: "person",
            sort: "asc",
            width: 60,
          },
          {
            label: "Seats",
            field: "seats",
            sort: "asc",
            width: 60,
          },
          {
            label: "price",
            field: "finalAmount",
            sort: "asc",
            width: 60,
          },

          ...(canWrite() ? [{
            label: "Update",
            field: "update",
            sort: "asc",
            width: 100,
          }] : []),

          ...(canWrite() ? [{
            label: "Status",
            field: "remove",
            sort: "asc",
            width: 100,
          }] : []),

          {
            label: "Occupied/Free",
            field: "freeTable",
            sort: "asc",
            width: 100,
          },
        ],
        rows: [],
      },
    };
    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
      tableNo: "",
      tableId: "",
      finalAmount: "",
      person: "",
      seats: "",
      branchIds: [],
      excludedBranchIds: [],
      branchOverrides: [],
      outletId: "",
    });
  }
  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit(e) {
    e.preventDefault();

    const tableData = {
      tableNo: this.state.tableNo,
      tableId: this.state.tableId,
      finalAmount: this.state.finalAmount,
      seats: this.state.seats,
      person: this.state.person,
      branchIds: this.state.branchIds || [],
      excludedBranchIds: this.state.excludedBranchIds || [],
      branchPriceOverrides: this.state.branchOverrides || [],
      // Always sent, so picking "Branch-wide" clears it: "" = no outlet.
      outletId: this.state.outletId || "",
    };
    // console.log(tableData);

    if (this.state.tableId == "" || this.state.tableId == null) {
      createTable(tableData)
        .then((response) => {
          console.log(response);
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                tableNo: "",
                tableId: "",
                finalAmount: "",
                seats: "",
                person: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Table added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateTable(tableData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                tableId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Table updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  removeTable(id, isActive) {
    const data = {
      tableId: id,
      isActive: isActive,
    };

    removetable(data)
      .then((results) => {
        console.log(results);
        if (results.status !== 200) {
          toast.error(results.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success("Table status updated successfully");
        }
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  freeTable(id, isOccupied) {
    const data = {
      tableId: id,
      isOccupied: isOccupied,
    };
    console.log(data);
    updatetablestatus(data)
      .then((results) => {
        console.log(results);
        if (results.status !== 200) {
          toast.error(results.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success("Table Occupied  status updated successfully");
        }
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  getALlluser() {
    getTableList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data,
        tableData: {
          ...this.state.tableData,
          rows: result.data,
          // No longer inverts isActive/isOccupied on the row.
          //
          // It used to, because both endpoints take the DESIRED state rather
          // than toggling, so the flipped value happened to be the right thing
          // to post. But the button LABELS were derived from the same flipped
          // field, so they described the opposite of reality: an active table
          // offered "Active" and deactivated when clicked, a hidden one offered
          // "Deactive". The rows are the same objects as `items`, so the floor
          // plan read the inverted values too.
          //
          // Fields are now left as stored and each control states the ACTION it
          // performs, with the target computed explicitly at the call site.
          // isOccupied defaults false and is set true when a guest books the
          // table (controllers/users/tableBooking.js), so true means occupied.
          list: result.data.map((x) => {
            x.update = canWrite() ? (
              <RowBtn onClick={() => this.editTable(x._id.toString(), x)}>
                Update
              </RowBtn>
            ) : null;
            x.remove = canWrite() ? (
              <RowBtn
                onClick={() => this.removeTable(x._id.toString(), !x.isActive)}
              >
                {x.isActive === true ? "Deactivate" : "Activate"}
              </RowBtn>
            ) : null;
            x.freeTable = canWrite() ? (
              <RowBtn
                tone="solid"
                onClick={() => this.freeTable(x._id.toString(), !x.isOccupied)}
              >
                {x.isOccupied === true ? "Mark free" : "Mark occupied"}
              </RowBtn>
            ) : null;
            return x;
          }),
        },
      });
    });
  }

  componentDidMount() {
    this.getALlluser();
    this.loadOutlets();
  }

  /** The outlets for the picker. The branch switcher reloads the page, so once is enough. */
  loadOutlets() {
    getOutlets().then((result) => {
      this.setState({ outlets: (result && result.data) || [] });
    });
  }

  /** True when the loaded outlets span more than one branch (super admin, no switcher). */
  outletsSpanBranches() {
    const ids = new Set(
      (this.state.outlets || []).map((o) => String((o.branchId && o.branchId._id) || o.branchId || ""))
    );
    return ids.size > 1;
  }

  /** "Rooftop Bar · Bar", plus the branch when several are in view, "(off)" when inactive. */
  outletLabel(o) {
    const kind = OUTLET_KIND_LABEL[o.kind] || o.kind;
    const branch = this.outletsSpanBranches() && o.branchId && o.branchId.name;
    return [o.name, kind, branch].filter(Boolean).join(" · ") + (o.active === false ? " (off)" : "");
  }

  /** The loaded outlet a table points at, or null (branch-wide, or not in view). */
  findOutlet(outletId) {
    const id = outletIdOf(outletId);
    if (!id) return null;
    return (this.state.outlets || []).find((o) => String(o._id) === id) || null;
  }
  editTable(id) {
    gettableId(id)
      .then((results) => {
        console.log(results);
        this.setState({
          tableNo: results.data.tableNo,
          tableId: results.data._id,
          finalAmount: results.data.finalAmount,
          seats: results.data.seats,
          person: results.data.person,
          branchIds: (results.data.branchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          excludedBranchIds: (results.data.excludedBranchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          branchOverrides: results.data.branchPriceOverrides || [],
          outletId: outletIdOf(results.data.outletId),
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.toggle();
  }

  /** isOccupied is stored as written: true means a guest is at the table. */
  isFree(x) {
    return x.isOccupied !== true;
  }

  /**
   * A table is "live" (in service, bookable) when isActive is true. This read
   * the inverted value before the flip was removed - which is why every active
   * table briefly rendered as Hidden and vice versa.
   */
  isLive(x) {
    return x.isActive === true;
  }

  /**
   * Display columns, derived from the permission-gated column list in state so
   * Update / Status still appear only for a writer.
   */
  consoleColumns() {
    const render = {
      tableNo: (x) => (
        <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
          <span
            style={{
              minWidth: 42, height: 34, padding: "0 10px", borderRadius: 10,
              background: this.isFree(x) ? C.iconTint : C.brown,
              color: this.isFree(x) ? C.brown : "#fff",
              display: "grid", placeItems: "center", fontSize: 14, fontWeight: 500,
            }}
          >
            T{x.tableNo}
          </span>
          {this.isLive(x) ? (
            <Chip tone={this.isFree(x) ? "good" : "neutral"}>
              {this.isFree(x) ? "Free" : "Seated"}
            </Chip>
          ) : (
            <Chip tone="warn">Hidden</Chip>
          )}
        </div>
      ),
      // getTableList returns the bare outlet id; map it through the loaded outlets.
      outlet: (x) => {
        if (!outletIdOf(x.outletId)) return null;
        const o = this.findOutlet(x.outletId);
        return o ? (
          <span style={{ color: C.ink }}>{o.name}</span>
        ) : (
          <span style={{ color: C.taupeLight }}>Unlisted outlet</span>
        );
      },
      person: (x) => <span style={{ color: C.taupe }}>{x.person || "—"}</span>,
      seats: (x) => <span style={{ color: C.ink }}>{x.seats || "—"}</span>,
      finalAmount: (x) => (
        <span style={{ fontSize: 15, fontWeight: 500, color: C.ink }}>
          ${Number(x.finalAmount || 0).toLocaleString()}
        </span>
      ),
      update: (x) => x.update,
      remove: (x) => x.remove,
      freeTable: (x) => x.freeTable,
    };

    const label = {
      tableNo: "Table",
      person: "Party",
      finalAmount: "Price",
      remove: "Activation",
      freeTable: "Occupancy",
    };

    return this.state.tableData.columns.map((c) => ({
      key: c.field,
      label: label[c.field] || c.label,
      render: render[c.field] || ((x) => x[c.field]),
    }));
  }

  /** One tile on the floor plan. */
  renderTile(x) {
    const free = this.isFree(x);
    const live = this.isLive(x);
    const style = !live
      ? { background: C.panel, color: C.taupe, border: `1px solid ${C.border}` }
      : free
      ? { background: "#fff", color: C.green, border: `1px solid ${C.border}` }
      : { background: C.brown, color: "#fff", border: "1px solid transparent" };

    return (
      <div
        key={x._id}
        title={`Table ${x.tableNo}`}
        style={{
          borderRadius: 14, minHeight: 78,
          display: "flex", flexDirection: "column",
          justifyContent: "center", alignItems: "center", gap: 4, ...style,
        }}
      >
        <span style={{ fontSize: 17, fontWeight: 500, color: live && !free ? "#fff" : C.ink }}>
          T{x.tableNo}
        </span>
        <span style={{ fontSize: 12, opacity: live && !free ? 0.75 : 1 }}>
          {x.seats || "?"} · {!live ? "hidden" : free ? "free" : "seated"}
        </span>
      </div>
    );
  }

  render() {
    const { items } = this.state;
    const tables = items || [];
    const live = tables.filter((x) => this.isLive(x));
    const free = live.filter((x) => this.isFree(x)).length;
    const seats = tables.reduce((s, x) => s + (parseInt(x.seats, 10) || 0), 0);

    return (
      <ConsolePage
        title="Tables"
        actions={
          <React.Fragment>
            <NavPills
              active="/Table"
              items={[
                { to: "/Table", label: "Floor plan" },
                { to: "/TableBooking", label: "Reservations" },
              ]}
            />
            {canWrite() && (
              <Btn icon="add" onClick={this.toggle}>
                New table
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={`con-modal ${this.props.className || ""}`}
          size="lg"
          scrollable
          contentClassName="bg-transparent border-0"
        >
          <div style={{ background: "#fdf9f3", borderRadius: 22, padding: 28 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
              <span
                className="ms"
                style={{ fontSize: 24, color: C.brown, background: C.iconTint, padding: 11, borderRadius: 14 }}
              >
                event_seat
              </span>
              <div style={{ flex: 1, fontSize: 20, fontWeight: 500, color: C.ink }}>
                Table details
              </div>
              <span
                className="ms"
                onClick={this.toggle}
                style={{ fontSize: 22, color: C.taupeLight, cursor: "pointer" }}
              >
                close
              </span>
            </div>
            <AvForm onValidSubmit={this.handleSubmit}>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="email">Table Number</Label>
                                <AvField
                                  type="number"
                                  min={1}
                                  value={this.state.tableNo}
                                  onChange={this.handleChange}
                                  id="tableNo"
                                  name="tableNo"
                                  required
                                  errorMessage="Table number is required"
                                />
                              </FormGroup>
                            </Col>

                            <Col md={6}>
                              <FormGroup>
                                <Label for="email">Amount (in usd)</Label>
                                <AvField
                                  type="number"
                                  min={1}
                                  value={this.state.finalAmount}
                                  onChange={this.handleChange}
                                  id="finalAmount"
                                  name="finalAmount"
                                  required
                                  errorMessage="Amount is required"
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="email">
                                  Total Seat (No of people can sit on the table)
                                </Label>
                                <AvField
                                  type="text"
                                  value={this.state.seats}
                                  onChange={this.handleChange}
                                  id="seats"
                                  name="seats"
                                  required
                                  errorMessage="Total seats is required"
                                />
                              </FormGroup>
                            </Col>

                            <Col md={6}>
                              <FormGroup>
                                <Label for="email">Table Occupancy Type</Label>
                                <Input
                                  type="select"
                                  value={this.state.person}
                                  onChange={this.handleChange}
                                  id="person"
                                  name="person"
                                  required
                                >
                                  <option>Select Person</option>
                                  <option value="Single">Single</option>
                                  <option value="Couple">Couple</option>
                                  <option value="Family">Family</option>
                                </Input>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="outletId">Outlet</Label>
                                <Input
                                  type="select"
                                  value={this.state.outletId}
                                  onChange={this.handleChange}
                                  id="outletId"
                                  name="outletId"
                                >
                                  <option value="">Branch-wide (no outlet)</option>
                                  {/* Keep an outlet that is not in view (another branch, or removed) selectable. */}
                                  {this.state.outletId && !this.findOutlet(this.state.outletId) && (
                                    <option value={this.state.outletId}>Current outlet (not listed)</option>
                                  )}
                                  {(this.state.outlets || []).map((o) => (
                                    <option key={o._id} value={String(o._id)}>
                                      {this.outletLabel(o)}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>
                          </Row>

                          <BranchAssignment
                            branchIds={this.state.branchIds}
                            excludedBranchIds={this.state.excludedBranchIds}
                            overrides={this.state.branchOverrides}
                            priceFields={[{ key: "finalAmount", label: "Price" }]}
                            onChange={({ branchIds, excludedBranchIds, overrides }) =>
                              this.setState({
                                branchIds,
                                excludedBranchIds,
                                branchOverrides: overrides,
                              })
                            }
                          />

                          <div style={{ marginTop: 22, display: "flex", justifyContent: "flex-end", gap: 12 }}>
                            <Button
                              type="button"
                              color="link"
                              onClick={this.toggle}
                              style={{ color: C.taupe, textDecoration: "none" }}
                            >
                              Cancel
                            </Button>
                            <button type="submit" style={SUBMIT_STYLE}>
                              Submit
                            </button>
                          </div>
            </AvForm>
          </div>
        </Modal>

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow>
            <StatCard icon="table_restaurant" value={tables.length} label="Tables on file" />
            <StatCard icon="groups" value={seats} label="Seats across all tables" />
            <StatCard icon="check_circle" value={free} label="Free right now" />
            <StatCard icon="chair_alt" value={live.length - free} label="Occupied right now" />
          </StatRow>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1.1fr", gap: 18, alignItems: "start" }}>
            <Panel
              title="Floor plan"
              subtitle={`${live.length} table${live.length === 1 ? "" : "s"} in service · ${free} free`}
              actions={
                <div style={{ display: "flex", alignItems: "center", gap: 16, fontSize: 13, color: C.slate }}>
                  {[["Free", C.green], ["Seated", C.brown], ["Hidden", C.border]].map(([l, c]) => (
                    <span key={l} style={{ display: "flex", alignItems: "center", gap: 7 }}>
                      <span style={{ width: 10, height: 10, borderRadius: 3, background: c }} />
                      {l}
                    </span>
                  ))}
                </div>
              }
            >
              <div
                style={{
                  marginTop: 18, borderRadius: 14, background: C.surface, padding: 20,
                  display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14,
                }}
              >
                {tables.length === 0 && (
                  <div style={{ gridColumn: "1 / -1", textAlign: "center", color: C.taupeLight, padding: "24px 0" }}>
                    {this.state.isLoaded ? "No tables yet" : "Loading tables…"}
                  </div>
                )}
                {tables.map((x) => this.renderTile(x))}
              </div>
            </Panel>

            <Panel style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "16px 22px", borderBottom: `1px solid ${C.panel}`,
                }}
              >
                <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>All tables</div>
                <Chip>{tables.length} total</Chip>
              </div>
              <div style={{ padding: "0 10px" }}>
                <Table
                  columns={this.consoleColumns()}
                  rows={tables}
                  empty={this.state.isLoaded ? "No tables yet" : "Loading tables…"}
                />
              </div>
            </Panel>
          </div>
        </div>
      </ConsolePage>
    );
  }
}

export default FormElements;
